import { DATADESC } from "../constants/app";
import { routes } from "../routes";

export interface NavLink {
  name: string;
  to: string | NavLink[];
  disabled?: boolean;
  tooltip?: string;
  newTab?: boolean;
  /** Full page load (not React Router), e.g. backend-served /terms/ */
  external?: boolean;
}

export const LandingLinks = [
  {
    name: "Vocabulary",
    to: [
      { name: "Vocabulary", to: routes.vocabulary.absolute, external: true },
      { name: "Schema docs", to: routes.schema.absolute },
    ],
  },
  { name: "Tools", to: routes.dashboard },
  {
    name: "Resources",
    to: [
      {
        name: "Preprint",
        to: "https://www.sciencedirect.com/science/article/pii/S2666389924002149",
        newTab: true,
      },
      {
        name: "GitHub Repository",
        to: `${DATADESC.github}/tree/main`,
        newTab: true,
      },
    ],
  },
  {
    name: "About",
    to: [
      { name: "Overview", to: routes.aboutOverview },
      { name: "Why DataDesc?", to: routes.aboutWhy },
      { name: "Team", to: routes.aboutTeam, disabled: true },
      { name: "FZJ/ICE-2", to: routes.aboutTeam },
      { name: "TIB", to: routes.aboutTeam },
      { name: "Uni Oldenburg/ OFFIS", to: routes.aboutTeam },
      { name: "Statistics", to: routes.aboutStatistics },
    ],
  },
];

export const DashboardLinks = [
  { name: "Annotate", to: routes.annotationTools.absolute },
  {
    name: "Compare",
    to: routes.compareMetadata.absolute,
    disabled: true,
    tooltip: "Coming soon",
  },
  {
    name: "Publish",
    to: routes.publicationTools.absolute,
    disabled: true,
    tooltip: "Coming soon",
  },
];
